const API = 'DietDiaryTypes';

export const API_DIET_DIARY_TYPES = {
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
};

export interface DietDiaryTypeSourceItem
  extends Pick<Components.Schemas.DietDiaryType, 'id' | 'title' | 'icon' | 'color'> {
    rowIndex: DietDiaryTypeRowIndex;
  }

export enum DietDiaryTypeRowIndex {
  Breakfast = 1,
  Lunch = 2,
  Dinner = 3,
  Snack = 4,
  Other = 5,
}
